import ElementEnum from '@/app/shared/ElementEnum.js';
import NSRForecastTypeEnum from '@/app/geo/gradecontrol/NSRForecastTypeEnum.js';

export default {
  props: {
    projectId: {
      type: Number,
      required: true
    },
    refDate: {
      type: Date,
      required: true
    }
  },
  watch: {
    projectId: {
      immediate: true,
      handler() {
        this.getAvailableElements();
        this.fetchData();
      }
    },
    refDate: {
      immediate: true,
      handler() {
        this.fetchData();
      }
    }
  },
  computed: {
    elements() {
      // This will probably never happen, but just in case...
      const monthlyElements = this.monthlyNsr.elements;
      const reserveElements = this.reserveNsr.elements;
      return [...new Set([...monthlyElements, ...reserveElements])]; // Union, see https://stackoverflow.com/a/27997088
    }
  },
  data() {
    return {
      // Enums (could maybe go into computed)
      nsrForecastTypes: NSRForecastTypeEnum.definition,
      elementEnum: ElementEnum.definition,

      // For the header
      availableElements: null,
  
      monthlyNsr: {
        // NSR Properties
        id: 0,
  
        // NSR State
        isLocked: false,
        lockedBy: null,
        lockedDate: null,
  
        // NSR Parameters
        cuAuRefineryCostPerTon: null,
        znRefineryCostPerTon: null,
        lowZnGradeAdditionalRefineryCostPerMetricTon: null,
        highZnGradeAdditionalRefineryCostPerMetricTon: null,
        highZnMinimumGrade: null,
  
        // Elements data:
        //  - element: ElementEnum
        //  - price: number
        //  - recoveryPct: number
        elements: [],
  
        // Currency exchange rate
        fxCurrency: null,
        fxRate: 0
      },
  
      reserveNsr: {
        // NSR Properties
        id: 0,
  
        // NSR State
        isLocked: false,
        lockedBy: null,
        lockedDate: null,
  
        // NSR Parameters
        cuAuRefineryCostPerTon: null,
        znRefineryCostPerTon: null,
        lowZnGradeAdditionalRefineryCostPerMetricTon: null,
        highZnGradeAdditionalRefineryCostPerMetricTon: null,
        highZnMinimumGrade: null,
  
        // Elements data:
        //  - element: ElementEnum
        //  - price: number
        //  - recoveryPct: number
        elements: [],
  
        // Currency exchange rate
        fxCurrency: null,
        fxRate: 0
      }
    };
  },
  methods: {
    getAvailableElements() {
      if (!this.projectId) return;

      const params = { projectId: this.projectId };
      this.$cqrsGet("core/projectElements/Find", { params })
        .then((response) => {
          this.availableElements = response.data.model;
        });
    },
    fetchData() {
      if (!this.projectId || !this.refDate) {
        return;
      }
      const params = {
        projectId: this.projectId,
        refDate: this.refDate
      };

      // Call for Monthly
      params.forecastType = NSRForecastTypeEnum.Monthly;
      this.$cqrsGet("geo/gradeControl/NetSmelterReturnForecast/Find", { params }, null)
        .then(response => {
          this.monthlyNsr = response.data.model;
        })
        .catch(() => {
        });

      // Call for Reserve
      params.forecastType = NSRForecastTypeEnum.Reserve;
      this.$cqrsGet("geo/gradeControl/NetSmelterReturnForecast/Find", { params }, null)
        .then(response => {
          this.reserveNsr = response.data.model;
        })
        .catch(() => {
        });
    },

    getNSRForecastElements(type) {
      if (type === NSRForecastTypeEnum.Monthly) {
        return this.monthlyNsr.elements;
      }
      return this.reserveNsr.elements;
    },

    getElementName(value) {
      return ElementEnum.getNameFor(value);
    }
  }
};
